import { Conversations451Api } from '../conversations451';

export interface TwilioToken {
  token: string;
}

export enum CallDirection {
  Inbound = 'inbound',
  OutboundApi = 'outbound-api',
  OutboundDial = 'outbound-dial'
}

export enum CallState {
  Ready = 'ready',
  Closed = 'closed',
  Connecting = 'connecting',
  Open = 'open',
  Pending = 'pending',
  Reconnecting = 'reconnecting',
  Ringing = 'ringing',
  Error = 'error'
}

export enum CallEvent {
  Accept = 'accept',
  Ringing = 'ringing',
  Cancel = 'cancel',
  Disconnect = 'disconnect',
  Error = 'error',
  Mute = 'mute',
  Unmute = 'unmute',
  Reconnected = 'reconnected',
  Reconnecting = 'reconnecting',
  Reject = 'reject'
}

export interface TwilioPhoneNumberCapabilities {
  voice: boolean;
  SMS: boolean;
  MMS: boolean;
}

export interface TwilioPhoneNumber {
  friendlyName: string;
  phoneNumber: string;
  locality: string;
  rateCenter: string;
  latitude: string;
  longitude: string;
  region: string;
  postalCode: string;
  isoCountry: string;
  capabilities: TwilioPhoneNumberCapabilities;
}

export enum SenderVertical {
  Automotive = 'Automotive',
  BeautySpaAndSalon = 'Beauty, Spa and Salon',
  ClothingAndApparel = 'Clothing and Apparel',
  Education = 'Education',
  Entertainment = 'Entertainment',
  EventPlanningAndService = 'Event Planning and Service',
  FinanceAndBanking = 'Finance and Banking',
  FoodAndGrocery = 'Food and Grocery',
  PublicService = 'Public Service',
  HotelAndLodging = 'Hotel and Lodging',
  MedicalAndHealth = 'Medical and Health',
  NonProfit = 'Non-profit',
  ProfessionalServices = 'Professional Services',
  ShoppingAndRetail = 'Shopping and Retail',
  TravelAndTransportation = 'Travel and Transportation',
  Restaurant = 'Restaurant',
  Other = 'Other'
}

export interface SenderWebsite {
  website: string;
  label: string;
}

export interface SenderEmail {
  email: string;
  label: string;
}
export interface SenderProfile {
  name: string;
  emails: SenderEmail[];
  websites: SenderWebsite[];
  about: string;
  address: string;
  logo_url: string;
  description: string;
  vertical: SenderVertical;
}

export interface SenderProfileDto {
  name: string;
  emails: string[];
  websites: string[];
  about?: string;
  address?: string;
  logo_url?: string;
  description?: string;
  vertical?: SenderVertical;
}

export interface SenderWebhooks {
  callback_method: 'GET' | 'POST' | 'PUT' | 'DELETE';
  callback_url: string;
  fallback_method: 'GET' | 'POST' | 'PUT' | 'DELETE';
  fallback_url: string;
  status_callback_url: string;
  status_callback_method: 'GET' | 'POST' | 'PUT' | 'DELETE';
}

export interface SenderConfiguration {
  waba_id: string;
}

export enum SenderStatus {
  Creating = 'CREATING',
  Online = 'ONLINE',
  Offline = 'OFFLINE',
  Verifying = 'VERIFYING',
  OnlineUpdating = 'ONLINE:UPDATING'
}

export interface SenderProperties {
  messaging_limit: string;
  quality_rating: 'HIGH' | string;
}

export interface Sender {
  status: SenderStatus;
  sender_id: string;
  sid: string;
  configuration: SenderConfiguration;
  profile: SenderProfile;
  webhook: SenderWebhooks;
  url: string;
  properties: SenderProperties;
}

export interface SenderDto {
  waba_id: string;
  name: string;
  phone_number: string;
  meta_login: Conversations451Api.MetaLoginResponse;
  website?: string;
  email?: string;
  about?: string;
  logo_url?: string;
}

export interface WhatsappSettings {
  senders: Sender[];
  meta_login?: Conversations451Api.MetaLoginResponse;
}
